import React, { useCallback, useRef } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { Grid } from '@material-ui/core'
import Loading from '../../../molecules/Loading'
import EmptySection from '../../../atoms/EmptySection'
import SydButton from '../../../commonDesign/Button'
import FlexRow from '../../../molecules/FlexRow'
import FlexActions from '../../../molecules/FlexActions'
import {
  useListManagedSchedules,
  useEnableManagedSchedule,
  useDisableManagedSchedule,
  useRemoveManagedSchedule
} from '../../../../api/scheduler'
import ScheduleTable from './ScheduleTable'
import ToggleScheduleDialog from './ToggleScheduleDialog'
import DeleteScheduleDialog from './DeleteScheduleDialog'

function SchedulerHome () {
  const history = useHistory()
  const { url } = useRouteMatch()
  const { data: schedules, isLoading } = useListManagedSchedules()
  const { mutateAsync: enableSchedule } = useEnableManagedSchedule()
  const { mutateAsync: disableSchedule } = useDisableManagedSchedule()
  const { mutateAsync: removeSchedule } = useRemoveManagedSchedule()

  const toggleRef = useRef(null)
  const deleteRef = useRef(null)

  const handleRowClick = useCallback((row) => {
    history.push(`${url}/${row.original.scheduleId}`)
  }, [history, url])

  const handleEnable = useCallback((schedule) => {
    toggleRef.current?.open(schedule)
  }, [])

  const handleDisable = useCallback((schedule) => {
    toggleRef.current?.open(schedule)
  }, [])

  const handleEdit = useCallback((schedule) => {
    history.push(`${url}/${schedule.scheduleId}/edit`)
  }, [history, url])

  const handleDelete = useCallback((schedule) => {
    deleteRef.current?.open(schedule)
  }, [])

  const handleToggleConfirm = useCallback(async (schedule) => {
    const mutation = schedule.enabled ? disableSchedule : enableSchedule
    await mutation({ scheduleId: schedule.scheduleId })
  }, [enableSchedule, disableSchedule])

  const handleDeleteConfirm = useCallback(async (schedule) => {
    await removeSchedule({ scheduleId: schedule.scheduleId })
  }, [removeSchedule])

  if (isLoading) {
    return <Loading />
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FlexRow style={{ width: '100%' }}>
            <h2 style={{ margin: 0 }}>Managed Schedules</h2>
            <FlexActions style={{ flex: 1 }}>
              <SydButton
                size='sm'
                variant='primary'
                icon='add'
                onClick={() => history.push(`${url}/new`)}
              >
                New Schedule
              </SydButton>
            </FlexActions>
          </FlexRow>
        </Grid>
        <Grid item xs={12}>
          {!schedules?.length ? (
            <EmptySection
              title='No Schedules'
              description='Create a new schedule to get started.'
            />
          ) : (
            <ScheduleTable
              schedules={schedules}
              onRowClick={handleRowClick}
              onEnable={handleEnable}
              onDisable={handleDisable}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          )}
        </Grid>
      </Grid>

      <ToggleScheduleDialog ref={toggleRef} onConfirm={handleToggleConfirm} />
      <DeleteScheduleDialog ref={deleteRef} onConfirm={handleDeleteConfirm} />
    </>
  )
}

export default SchedulerHome
